import { Box, Container, Link, Typography } from "@mui/material";

const colors = {
    cream: "#fffaf2",
    paper: "rgba(255, 250, 242, 0.9)",
    ink: "#2a2621",
    muted: "rgba(42, 38, 33, 0.68)",
    brown: "#9b7653",
    brownDark: "#6f5136",
};

function SectionTitle({ children }) {
    return (
        <Typography
            component="h2"
            sx={{
                mt: 5,
                mb: 2,
                fontFamily: '"Quicksand", sans-serif',
                fontSize: {
                    xs: "1.7rem",
                    md: "2.1rem",
                },
                lineHeight: 1.15,
                fontWeight: 700,
                letterSpacing: "-0.04em",
                color: colors.ink,
            }}
        >
            {children}
        </Typography>
    );
}

function TextBlock({ children }) {
    return (
        <Typography
            sx={{
                mb: 2,
                fontFamily: '"Nunito Sans", sans-serif',
                fontSize: {
                    xs: 16,
                    md: 17,
                },
                lineHeight: 1.8,
                color: colors.muted,
            }}
        >
            {children}
        </Typography>
    );
}

function ListBlock({ children }) {
    return (
        <Box
            component="ul"
            sx={{
                pl: 2.5,
                mb: 2,
                color: colors.muted,

                "& li": {
                    mb: 1.2,
                    fontFamily: '"Nunito Sans", sans-serif',
                    fontSize: {
                        xs: 16,
                        md: 17,
                    },
                    lineHeight: 1.7,
                },
            }}
        >
            {children}
        </Box>
    );
}

function FormLine({ children }) {
    return (
        <Typography
            sx={{
                mb: 1.5,
                fontFamily: '"Nunito Sans", sans-serif',
                fontSize: {
                    xs: 16,
                    md: 17,
                },
                lineHeight: 1.7,
                color: colors.muted,
            }}
        >
            {children}
        </Typography>
    );
}

function Widerrufsrecht() {
    return (
        <Box
            component="main"
            sx={{
                minHeight: "100vh",
                py: {
                    xs: 10,
                    md: 14,
                },
                background:
                    "linear-gradient(180deg, #fffaf2 0%, #f7f1e8 55%, #eef7fa 100%)",
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    width: "100%",
                    maxWidth: 980,
                    mx: "auto",
                    px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                }}
            >
                <Box
                    sx={{
                        p: {
                            xs: 3,
                            sm: 4,
                            md: 6,
                        },
                        borderRadius: {
                            xs: 5,
                            md: 7,
                        },
                        backgroundColor: colors.paper,
                        border: "1px solid rgba(155,118,83,0.15)",
                        boxShadow: "0 24px 80px rgba(78,54,30,0.09)",
                    }}
                >
                    <Typography
                        component="p"
                        sx={{
                            mb: 1.2,
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSize: 13,
                            fontWeight: 900,
                            letterSpacing: "0.17em",
                            textTransform: "uppercase",
                            color: colors.brown,
                        }}
                    >
                        Rechtliches
                    </Typography>

                    <Typography
                        component="h1"
                        sx={{
                            mb: 4,
                            fontFamily: '"Quicksand", sans-serif',
                            fontSize: {
                                xs: "2.6rem",
                                sm: "3.4rem",
                                md: "4.4rem",
                            },
                            lineHeight: 0.98,
                            fontWeight: 700,
                            letterSpacing: "-0.06em",
                            color: colors.ink,
                        }}
                    >
                        Widerrufsbelehrung
                    </Typography>

                    <SectionTitle>Widerrufsrecht</SectionTitle>

                    <TextBlock>
                        Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
                        diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn
                        Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter,
                        der nicht der Beförderer ist, die letzte Ware in Besitz genommen
                        haben bzw. hat.
                    </TextBlock>

                    <TextBlock>
                        Um Ihr Widerrufsrecht auszuüben, müssen Sie uns, Hooksieler
                        Lädchen - Mode & Mee(h)r, Lange Str. 37, 26434 Wangerland,
                        Deutschland,{" "}
                        <Link
                            href="mailto:info@hooksieler-laedchen.de"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            info@hooksieler-laedchen.de
                        </Link>
                        , Telefon:{" "}
                        <Link
                            href="tel:+494425353"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            04425-353
                        </Link>
                        , Fax: 04425-6759821, mittels einer eindeutigen Erklärung, zum
                        Beispiel ein mit der Post versandter Brief, Telefax oder E-Mail,
                        über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
                        Sie können dafür das beigefügte Muster-Widerrufsformular
                        verwenden, das jedoch nicht vorgeschrieben ist.
                    </TextBlock>

                    <TextBlock>
                        Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die
                        Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der
                        Widerrufsfrist absenden.
                    </TextBlock>

                    <SectionTitle>Folgen des Widerrufs</SectionTitle>

                    <TextBlock>
                        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
                        die wir von Ihnen erhalten haben, einschließlich der Lieferkosten,
                        mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass
                        Sie eine andere Art der Lieferung als die von uns angebotene,
                        günstigste Standardlieferung gewählt haben, unverzüglich und
                        spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem
                        die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
                        eingegangen ist.
                    </TextBlock>

                    <TextBlock>
                        Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das
                        Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei
                        denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in
                        keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte
                        berechnet.
                    </TextBlock>

                    <TextBlock>
                        Wir können die Rückzahlung verweigern, bis wir die Waren wieder
                        zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass
                        Sie die Waren zurückgesandt haben, je nachdem, welches der frühere
                        Zeitpunkt ist.
                    </TextBlock>

                    <TextBlock>
                        Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen
                        vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses
                        Vertrags unterrichten, an uns zurückzusenden oder zu übergeben. Die
                        Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von
                        vierzehn Tagen absenden.
                    </TextBlock>

                    <TextBlock>
                        Sie tragen die unmittelbaren Kosten der Rücksendung der Waren. Sie
                        müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn
                        dieser Wertverlust auf einen zur Prüfung der Beschaffenheit,
                        Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang
                        mit ihnen zurückzuführen ist.
                    </TextBlock>

                    <SectionTitle>
                        Das Widerrufsrecht besteht nicht bei den folgenden Verträgen
                    </SectionTitle>

                    <ListBlock>
                        <li>
                            Verträge zur Lieferung von Waren, die nicht vorgefertigt sind
                            und für deren Herstellung eine individuelle Auswahl oder
                            Bestimmung durch den Verbraucher maßgeblich ist oder die
                            eindeutig auf die persönlichen Bedürfnisse des Verbrauchers
                            zugeschnitten sind.
                        </li>
                        <li>
                            Verträge zur Lieferung von Waren, die schnell verderben können
                            oder deren Verfallsdatum schnell überschritten würde.
                        </li>
                        <li>
                            Verträge zur Lieferung versiegelter Waren, die aus Gründen des
                            Gesundheitsschutzes oder der Hygiene nicht zur Rückgabe
                            geeignet sind, wenn ihre Versiegelung nach der Lieferung
                            entfernt wurde.
                        </li>
                        <li>
                            Verträge zur Lieferung von Waren, wenn diese nach der Lieferung
                            aufgrund ihrer Beschaffenheit untrennbar mit anderen Gütern
                            vermischt wurden.
                        </li>
                    </ListBlock>

                    <SectionTitle>Muster-Widerrufsformular</SectionTitle>

                    <TextBlock>
                        Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte
                        dieses Formular aus und senden Sie es zurück.
                    </TextBlock>

                    <Box
                        sx={{
                            mt: 3,
                            p: {
                                xs: 2.5,
                                md: 3.5,
                            },
                            borderRadius: 4,
                            backgroundColor: "#fff",
                            border: "1px solid rgba(155,118,83,0.18)",
                        }}
                    >
                        <FormLine>
                            An Hooksieler Lädchen - Mode & Mee(h)r, Lange Str. 37, 26434
                            Wangerland, Deutschland, info@hooksieler-laedchen.de, Fax:
                            04425-6759821
                        </FormLine>

                        <FormLine>
                            Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*)
                            abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) /
                            die Erbringung der folgenden Dienstleistung (*):
                        </FormLine>

                        <FormLine>Bestellt am (*) / erhalten am (*):</FormLine>

                        <FormLine>Name des/der Verbraucher(s):</FormLine>

                        <FormLine>Anschrift des/der Verbraucher(s):</FormLine>

                        <FormLine>
                            Unterschrift des/der Verbraucher(s), nur bei Mitteilung auf
                            Papier:
                        </FormLine>

                        <FormLine>Datum:</FormLine>

                        <Typography
                            sx={{
                                mt: 2,
                                fontFamily: '"Nunito Sans", sans-serif',
                                fontSize: 14,
                                lineHeight: 1.6,
                                color: "rgba(42,38,33,0.58)",
                            }}
                        >
                            (*) Unzutreffendes streichen.
                        </Typography>
                    </Box>

                    <TextBlock>
                        Widerrufsbelehrung erstellt mit dem Trusted Shops Rechtstexter in
                        Kooperation mit Wilde Beuger Solmecke Rechtsanwälte.
                    </TextBlock>
                </Box>
            </Container>
        </Box>
    );
}

export default Widerrufsrecht;